/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { TransferContainerAssociationPaging } from '../model/transferContainerAssociationPaging';
import { TransferContainerEntry } from '../model/transferContainerEntry';
import { BaseApi } from './base.api';
import { buildCollectionParam } from '../../../alfrescoApiClient';
import { throwIfNotDefined } from '../../../assert';
export class TransferContainersApi extends BaseApi {
    getTransferContainer(transferContainerId, opts) {
        throwIfNotDefined(transferContainerId, 'transferContainerId');
        const pathParams = {
            transferContainerId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/transfer-containers/{transferContainerId}',
            pathParams,
            queryParams,
            returnType: TransferContainerEntry
        });
    }
    listTransfers(transferContainerId, opts) {
        throwIfNotDefined(transferContainerId, 'transferContainerId');
        opts = opts || {};
        const pathParams = {
            transferContainerId
        };
        const queryParams = {
            skipCount: opts === null || opts === void 0 ? void 0 : opts.skipCount,
            maxItems: opts === null || opts === void 0 ? void 0 : opts.maxItems,
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            includeSource: opts === null || opts === void 0 ? void 0 : opts.includeSource,
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/transfer-containers/{transferContainerId}/transfers',
            pathParams,
            queryParams,
            returnType: TransferContainerAssociationPaging
        });
    }
    updateTransferContainer(transferContainerId, nodeBodyUpdate, opts) {
        throwIfNotDefined(transferContainerId, 'transferContainerId');
        throwIfNotDefined(nodeBodyUpdate, 'nodeBodyUpdate');
        opts = opts || {};
        const pathParams = {
            transferContainerId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.put({
            path: '/transfer-containers/{transferContainerId}',
            pathParams,
            queryParams,
            bodyParam: nodeBodyUpdate,
            returnType: TransferContainerEntry
        });
    }
}
